var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgErgonomieMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 360 387",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360 387V42.255s-58 33.383-120.5-5.63C170-6.76 96-19.418 0 42.254V387h360z",
    fill: "#078DBE",
    fillOpacity: 0.5
  })));
}

export default __webpack_public_path__ + "36309b3de5a12d8c30f2ee0692eb4a91.svg";
export { SvgErgonomieMobile as ReactComponent };